<script>
  import FileDrop from "./FileDrop.svelte";

  export let userId, initialMediaUrl

  // the file drop component is set to work with multiple files
  // because here we only care about the first one, we have this workaround
  let userMedias = initialMediaUrl != undefined ? [initialMediaUrl] : []
  $: mediaUrl = userMedias.length > 0 ? userMedias[userMedias.length - 1].url : ""

</script>
<div class="w-full text-center">
  <img class="object-cover w-32 h-32 mx-auto my-6 border rounded-full border-secondary" src="{mediaUrl || initialMediaUrl}" alt="">
</div>

<div class="lg:max-w-sm xl:max-w-none">
  <FileDrop accept="image/*" uploadParam="media" uploadEndpoint="/users/{userId}/user_medias" bind:allFiles={userMedias}>
    <p slot="header" class="font-semibold">
      Choisissez votre nouvelle photo de profil
    </p>
  </FileDrop>
</div>
